export const pageLoad = () => {
  setTimeout(() => {
    const focus = document.getElementById('autoFocusTop');
    if (focus && !window.location.href.includes('#')) {
      focus?.focus();
    }
  }, 1000);
};

export const footerFocus = () => {
  window.addEventListener(
    'focus',
    function () {
      const footerFocus = document.getElementById('autoFocusFooter');
      const isFocused = document.activeElement === footerFocus;
      if (isFocused) {
        const focusTop = document.getElementById('autoFocusTop');
        if (focusTop) {
          focusTop?.focus();
        }
      }
    },
    true
  );
};
